
import { DeleteOutlined, PaperClipOutlined, UploadOutlined } from '@ant-design/icons'
import { Button, message, Upload } from 'antd'
import Modal from 'antd/lib/modal/Modal'
import { UploadFile, UploadProps } from 'antd/lib/upload/interface'
import { downloadModelRepository } from 'egi/repositories/ImportRepository'

import React, { useState } from 'react'
import { IImportTypes } from '../../importInterfaces'

interface IProps {
  type: IImportTypes
  visible: boolean
  onCancel: () => void
}

function UploadImportModelModal ({ type, visible, onCancel }: IProps) {
  const [loading, setLoading] = useState<boolean>()
  const [loadingSend, setLoadiingSend] = useState<boolean>(false)
  const [file, setFile] = useState<UploadFile>()

  const typeMap = {
    [IImportTypes.notaryFees]: 'custas cartorárias',
    [IImportTypes.outstandingBalance]: 'módulo de saldo devedor'
  }
  const selectedType = typeMap[type]

  const uploadImportModel = async (file: UploadFile) => {
    setLoadiingSend(true)
    try {
      const formData = new FormData()
      const headers = {
        headers: {
          'Content-Type': undefined
        }
      }

      formData.append('file', file?.originFileObj as Blob)

      if (type === IImportTypes.notaryFees) {
        await downloadModelRepository.uploadNotaryFeesModel(formData, headers)
      } else {
        await downloadModelRepository.uploadOutstandingBalanceModel(formData, headers)
      }

      message.success(`o arquivo ${file.name} está sendo processado`)
      onCancel()
    } catch (err: any) {
      message.error(err.message || `Não foi possível enviar o arquivo ${file.name}`)
    } finally {
      setLoadiingSend(false)
    }
  }

  const props: UploadProps = {
    name: 'file',
    maxCount: 1,
    showUploadList: false,
    action: 'https://www.mocky.io/v2/5cc8019d300000980a055e76',
    onChange: (info) => {
      const { file } = info
      if (file.status === 'uploading') {
        setLoading(true)
      }
      if ((file.status === 'done' || file.status === 'error') && file.originFileObj) {
        setLoading(false)
        setFile(file)
      }
    },

    beforeUpload: (file) => {
      const isSpreadsheet = file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' || file.type === 'text/csv'

      if (!isSpreadsheet) {
        message.error(`${file.name} não é um formato válido`)
      }

      return isSpreadsheet
    }
  }

  return (
    <Modal
      title={`Fazer upload de modelo de ${selectedType}`}
      visible={visible}
      destroyOnClose={true}
      onCancel={onCancel}
      footer={
        <div className="text-right m-2">
          <Button type="primary"
            onClick={() => { if (file) uploadImportModel(file) }}
            loading={loadingSend}>
            Enviar
          </Button>
          <Button
            type="ghost"
            onClick={onCancel}>
            Cancelar
          </Button>
        </div>
      }
    >
      <Upload {...props}>
        <Button type="primary"
          icon={<UploadOutlined />}
          className="m-1"
          loading={loading}>
          Importar planilha
        </Button>
      </Upload>

      {file && <div className="mt-2">
        <b>Arquivo selecionado:</b>
        <div className="import__upload-list-item">
          <span>
            <PaperClipOutlined className="pr-1" />
            {file?.name}
          </span>
          <DeleteOutlined
            className="import__upload-list-item-delete"
            onClick={() => setFile(undefined)} />
        </div>
      </div>
      }

    </Modal>

  )
}

export default UploadImportModelModal
